import { render, staticRenderFns } from "./SportMembershipsStoreContainer.vue?vue&type=template&id=70654166&scoped=true"
import script from "./SportMembershipsStoreContainer.vue?vue&type=script&lang=js"
export * from "./SportMembershipsStoreContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70654166",
  null
  
)

export default component.exports